import React, { useState, useEffect, useRef } from "react";

import BlackPlay from "../../assets/blackPlay.png";

import MiniGameCard from "../../Components/Test/MiniGameCard";
import heroMobile from "../../assets/mobileGroup.png";
import { Carousel, Dropdown } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import useGames from "../../customHooks/useGames"; // Adjust the import according to your project structure
import { IconsLoader } from "../../imports/icon"; // Adjust the import according to your project structure
import { change } from "../../redux/lang";
import { useEnvironment } from "../../context/EnvironmentContext";
import { useNavigate } from "react-router-dom";

const TestHome = () => {
  const auth = useSelector((state) => state?.user.value);
  const language = useSelector((state) => state.lang.language);
  const { games, isLoadingSet } = useGames(auth?.token);
  const { isWebViewApp } = useEnvironment();
  const [isInstallable, setIsInstallable] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const isLogedIn = useSelector((state) => state.user.isLogedIn);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const carouselRef = useRef(null);
  // console.log(games);
  const dispatch = useDispatch();
  const changeLanguage = (lang) => {
    dispatch(change(lang));
  };
  const items = [
    {
      key: 1,
      value: "am",
      label: (
        <a className="xl:text-[1vw]" onClick={() => changeLanguage("am")}>
          Amharic
        </a>
      ),
    },
    {
      key: 2,
      value: "en",
      label: (
        <a className="xl:text-[1vw]" onClick={() => changeLanguage("en")}>
          English
        </a>
      ),
    },
    {
      key: 3,
      value: "or",
      label: (
        <a className="xl:text-[1vw]" onClick={() => changeLanguage("or")}>
          Oromo
        </a>
      ),
    },
    {
      key: 4,
      value: "af",
      label: (
        <a className="xl:text-[1vw]" onClick={() => changeLanguage("af")}>
          Afar
        </a>
      ),
    },
    {
      key: 5,
      value: "ti",
      label: (
        <a className="xl:text-[1vw]" onClick={() => changeLanguage("ti")}>
          Tigrinya
        </a>
      ),
    },
    {
      key: 6,
      value: "so",
      label: (
        <a className="xl:text-[1vw]" onClick={() => changeLanguage("so")}>
          Somali
        </a>
      ),
    },
  ];

  const navigation = useNavigate();
  const routersAuth = () => {
    if (!auth?.token) {
      navigation({ pathname: "/auth" });
    } else {
      navigation({ pathname: "/" });
    }
  };
  React.useEffect(() => {
    routersAuth();
  }, []);
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);
  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === "accepted") {
      // console.log('User accepted the install prompt');
    } else {
      // console.log('User dismissed the install prompt');
    }

    // Clear the deferredPrompt so it can only be used once
    setDeferredPrompt(null);
    setIsInstallable(false);
  };
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Prevent the mini-infobar from appearing on mobile
      setDeferredPrompt(e); // Save the event so it can be triggered later.
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);
  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className=" w-20 absolute z-30 top-[80.5vh] md:top-[57.5vh] cursor-pointer  right-32 pl-4 hover:bg-[#0e0e0e6e]/10 rounded-3xl"
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <IconsLoader icon={"carausal-next"} width={50} height={50} />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className="w-20  absolute z-30 top-[58.5vh]  left-32 pl-4 cursor-pointer md:visible hover:bg-[#0e0e0e6e]/10 invisible  rounded-3xl"
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <IconsLoader icon={"carausal-previous"} width={50} height={50} />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  useEffect(() => {}, [isLoadingSet]);
  return (
    <Carousel
      dots={false}
      arrows
      draggable
      ref={carouselRef}
      fade
      className={`w-[100vw] ${
        false ? "h-[100vh]  " : "h-[90vh] "
      } sm:h-[93vh]  md:h-[94vh]`}
    >
      {games.map((item, index) => {
        const imageUrl = screenWidth < 570 ? item?.image[1] : item?.image[0];
        return (
          <div
            key={index}
            className={`w-[100vw]  md:relative  ${
              isWebViewApp ? "h-[100vh]" : "h-[90vh]"
            }  sm:h-[100vh] md:h-[95vh] bg-cover bg-center p-0 m-0`}
          >
            <img
              src={imageUrl}
              className={`w-[100%] ${
                false ? "h-[100vh]" : "h-[90vh]"
              } md:h-[100%] absolute`}
              alt="data"
            />
            <div className="w-[100%]   min-h-[110vh] md:min-h-[95vh] flex flex-col px-10 md:px-0  justify-center md:justify-end  pb-10 md:pb-16 self-start absolute bg-gradient-to-b from-[#000000ad]/50 from-[0%] via-[#8dc63f] via-[80%] to-[#febe01] to-[98%] pt-5">
              <div className="h-[50px] px-2 flex flex-row items-center md:px-12 pb-10">
                <div className="relative p-2 rounded-xl border-[4px] border-transparent">
                  <div className="absolute inset-0 rounded-xl border-[4px] border-transparent before:absolute before:inset-0 before:rounded-xl before:border-[4px] before:border-transparent before:bg-gradient-to-r before:from-transparent before:via-white before:to-transparent before:bg-[length:200%_auto] before:animate-shimmer-border"></div>
                  <div className="relative z-10">
                    <img
                      src={item.icon}
                      width={100}
                      alt="GameImage"
                      height={80}
                      className="w-[50px] object-contain h-[50px] md:w-[100px] md:h-[100px] rounded-md xl:w-[5vw] xl:h-[10vh]"
                    />
                  </div>
                </div>
                <h1 className="ml-5 font-milkb text-center text-2xl md:text-4xl uppercase text-[white] 2xl:text-[2vw]">
                  {item.name[language.lang]}
                </h1>
              </div>

              <Link
                // to={
                //   isLogedIn
                //     ? {
                //         pathname: "/playing",
                //         search: `?name=${item.name["en"]}&url=${
                //           item.gameUrl
                //         }&with_history=${item.with_history || false}`,
                //       }
                //     : "/auth"
                // }
                className="flex flex-col justify-center align-center items-center mt-[30vh] sm:mt-[20vh]"
              >
                <div className="  flex gap-5   items-start  md:px-0  flex-col md:min-w-60">
                  <Link
                    to={
                      isLogedIn
                        ? {
                            pathname: "/playing",
                            search: `?name=${item.name["en"]}&url=${
                              item.gameUrl
                            }&with_history=${item.with_history || false}`,
                          }
                        : "/auth"
                    }
                    className=" w-52 flex transition-transform duration-300 ease-in-out transform hover:scale-105 items-center space-x-4 justify-center bg-white rounded-lg text-lg  font-gothamb px-4 py-2"
                  >
                    <img src={BlackPlay} className=" w-6 h-6" />
                    <span className="text-black hover:text-black">
                      {" "}
                      {language?.playNowHome || "Play Now"}
                    </span>
                  </Link>
                  <div className=" relative rounded-2xl h-[200px]   md:h-auto flex items-center gap-3 md:w-max   shadow-[0px_0px_24.7px_8px_#b48600] z-100 p-3  bg-gradient-to-b from-[#FEBE01] to-[#8DC63F]   text-black">
                    {(() => {
                      const prevIndex =
                        (index - 1 + games.length) % games.length;
                      const nextIndex = (index + 1) % games.length;

                      const prevImage = games[prevIndex]?.image?.[0];
                      const currentImage = games[index]?.image?.[0];
                      const nextImage = games[nextIndex]?.image?.[0];

                      return [prevImage, currentImage, nextImage]
                        .filter(Boolean)
                        .map((img, imgIndex) => (
                          <MiniGameCard key={imgIndex} item={img} />
                        ));
                    })()}

                    {/* left arrow */}
                    <div
                      className="absolute left-[-60px] top-1/2 transform -translate-y-1/2 cursor-pointer z-50 hover:bg-black/10 rounded-full p-2"
                      onClick={() => carouselRef.current?.prev()}
                    >
                      <IconsLoader
                        icon="carausal-previous"
                        width={50}
                        height={50}
                      />
                    </div>
                    {/* right arrow */}
                    <div
                      className="absolute right-[-60px] top-1/2 transform -translate-y-1/2 cursor-pointer z-50 hover:bg-black/10 rounded-full p-2"
                      onClick={() => carouselRef.current?.next()}
                    >
                      <IconsLoader
                        icon="carausal-next"
                        width={50}
                        height={50}
                      />
                    </div>
                  </div>
                </div>
              </Link>
              <div className="self-center  sm:visible text-center">
                {/* <p
                  className={`text-white text-center text-xs md:text-[16px] max-w-[70vw] uppercase font-milkb ${
                    isInstallable ? "" : "pb-10"
                  }`}
                ></p>
                {isInstallable && (
                  <button
                    onClick={handleInstallClick}
                    className="text-[#FF9900] text-center font-milkb mt-3 text-xs md:text-lg hover:text-[#ff7b00]"
                  >
                    {language.download}
                  </button>
                )} */}
              </div>
            </div>
          </div>
        );
      })}
    </Carousel>
  );
};

export default TestHome;
